import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_BACKGROUND_LIGHT,
  COLOR_BACKGROUND_PRIMARY,
  COLOR_BORDER_DEFAULT,
  COLOR_TEXT_PRIMARY,
  COLOR_TEXT_SECONDARY,
} from '../colors/colors';

const Container = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  gap: 12px;
  margin-top: 16px;
  border-radius: ${RADIUS.MD};
  border: 1px solid ${COLOR_BORDER_DEFAULT};
  background: ${COLOR_BACKGROUND_PRIMARY};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: ${RADIUS.CIRCLE};
  overflow: hidden;
  flex-shrink: 0;
  background: ${COLOR_BACKGROUND_LIGHT};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

const Cpf = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${COLOR_TEXT_PRIMARY};
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: ${COLOR_TEXT_SECONDARY};

  img {
    width: 16px;
    height: 16px;
  }
`;

const Chevron = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: ${({ $expanded }) => ($expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const maskCpf = (cpf) => {
  if (!cpf) return '';
  const digits = cpf.replace(/\D/g, '');
  if (digits.length !== 11) return cpf;
  return `•••.${digits.slice(3, 6)}.${digits.slice(6, 9)}-••`;
};

const YouIdentityCard = ({
  cpf,
  avatarUrl,
  avatarAlt = 'Avatar',
  label = 'Identidade governamental',
  verifiedBadgeSrc,
  verifiedAlt = 'Verificado',
  chevronSrc,
  expanded = false,
  onClick,
}) => {
  const displayCpf = maskCpf(cpf);

  return (
    <Container
      onClick={onClick}
      data-testid="identity-card"
      aria-expanded={onClick ? expanded : undefined}
    >
      <Avatar>
        <img src={avatarUrl} alt={avatarAlt} />
      </Avatar>

      <Info>
        <Cpf data-testid="identity-cpf">{displayCpf}</Cpf>
        <Label>
          {label}
          {verifiedBadgeSrc && (
            <img src={verifiedBadgeSrc} alt={verifiedAlt} />
          )}
        </Label>
      </Info>

      {chevronSrc && (
        <Chevron src={chevronSrc} alt="" $expanded={expanded} data-testid="identity-chevron" />
      )}
    </Container>
  );
};

YouIdentityCard.propTypes = {
  cpf: PropTypes.string,
  avatarUrl: PropTypes.string,
  avatarAlt: PropTypes.string,
  label: PropTypes.string,
  verifiedBadgeSrc: PropTypes.string,
  verifiedAlt: PropTypes.string,
  chevronSrc: PropTypes.string,
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
};

export { YouIdentityCard };
